import axios from 'axios'
import qs from 'qs'
import $store from '../store'
import toLogin from '@utils/login'
import toast from '@utils/toast'
import _vue from '@/main.js'

const instance = axios.create({
  timeout: 300000
})

const defaultOpt = {
  login: true
}

instance.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // 请求错误时做些事(接口错误、超时等)
    // Tip: 4
    // 关闭loadding
    console.log('request error', error)

    // 1.判断请求超时
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      console.log('根据你设置的timeout/真的请求超时 判断请求现在超时了，你可以在这里加入超时的处理方案')
      return service.request(originalRequest) // 例如再重复请求一次
    }
    // 2.需要重定向到错误页面
    // const errorInfo = error.response
    // console.log(errorInfo)
    // if (errorInfo) {
    //   // error =errorInfo.data//页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
    //   const errorStatus = errorInfo.status; // 404 403 500 ... 等
    //   router.push({
    //     path: `/error/${errorStatus}`
    //   })
    // }
    return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
  }
)

function baseRequest (options) {
  const token = $store.state.app.token
  const headers = options.headers || {}
  if (!headers['content-type']) headers['content-type'] = 'application/x-www-form-urlencoded'
  headers['openid'] = token
  options.headers = headers
  if (options.method == 'post' && headers['content-type'] != 'multipart/form-data') {
    options.data = options.data || {}
    options.data.OPENID = token
    options.data = qs.stringify(options.data)
  }
  const prj_code = $store.state.app.prj_code
  if (options.url.indexOf('/ashx/') == -1) {
    options.url = '/ashx/' + prj_code + '/' + options.url
  }
  // console.log('before request options', options, token)

  if (options.login && !token) {
    // console.log('before request options to login')
    loadingHide()
    toLogin()
    return Promise.reject({
      msg: '未登录',
      toLogin: true
    })
  }
  if (options.loading) loadingShow()
  return instance(options).then(res => {
    loadingHide()
    // console.log('request then', res.data)
    const data = res.data || {}
    if (data.Code === -1) {
      toLogin()
      return Promise.reject({
        msg: res.data.Msg,
        res,
        data,
        toLogin: true
      })
    } else if (data.Code === 1) {
      return Promise.resolve(data.Data)
    } else if (data.Code === 0 && options.errorTips !== false) {
      toast.text(data.Msg)
      return Promise.reject(data)
    } else {
      return Promise.reject(data)
    }
  })
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ['post', 'put', 'patch'].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        data,
        method
      }, defaultOpt, options)
    )
  }
  return request
}, {});

['get', 'delete', 'head'].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        params,
        method
      }, defaultOpt, options)
    )
  }
})

function loadingShow () {
  _vue && _vue.$vux && _vue.$vux.loading && !_vue.$vux.loading.isVisible() && _vue.$vux.loading.show()
}

function loadingHide () {
  _vue && _vue.$vux && _vue.$vux.loading && _vue.$vux.loading.isVisible() && _vue.$vux.loading.hide()
}
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js